import { Controller, useFormContext } from "react-hook-form";
import { Select } from "@luna-restaurant/ui";
export function FormSelect({ name, ...inputProps }) {
    const { control } = useFormContext();
    return (<Controller control={control} name={name} render={({ field: { onChange, onBlur, value }, fieldState }) => (<Select value={value} onChange={(value) => {
                onChange(value);
                onBlur();
            }} error={fieldState.error?.message ?? false} {...inputProps}/>)}/>);
}
//# sourceMappingURL=FormSelect.js.map